export default __webpack_public_path__ + "static/jennifer_wadella-b049bcea1d6f553141b3f7165ff55fb3.jpg";